/**
 * `?open=giving` on the profile page opens that card's sheet on arrival; the
 * login drawer's "See all giving" links there. Read once and taken off the
 * URL, so a reload or a shared link does not reopen it.
 */
export function consumeOpenParam(name: string): boolean {
  if (typeof window === 'undefined') return false;
  const url = new URL(window.location.href);
  if (url.searchParams.get('open') !== name) return false;
  url.searchParams.delete('open');
  window.history.replaceState(window.history.state, '', url);
  return true;
}

/** The page URL with `open=<name>` added, whether or not it already carries a query. */
export function withOpenParam(pageUrl: string, name: string): string {
  return `${pageUrl}${pageUrl.includes('?') ? '&' : '?'}open=${encodeURIComponent(name)}`;
}
